<template>
  <v-card class="mx-auto rounded-xl mt-5 pa-5" elevation="4" max-width="500">
    <v-card-title
      class="
        justify-center
        font-weight-bold
        grey--text
        text--darken-3 text-h4 text-no-wrap
      "
    >
      Log In
    </v-card-title>

    <v-divider></v-divider>

    <v-form ref="form" @submit.prevent="signIn" class="mt-4">
      <small v-if="error" class="red--text">{{ error }}</small>

      <v-text-field
        v-model="email"
        label="Email"
        type="email"
        prepend-icon="mdi-email"
        required
      ></v-text-field>

      <v-text-field
        v-model="password"
        label="Password"
        :type="showPassword ? 'text' : 'password'"
        prepend-icon="mdi-lock"
        :append-icon="showPassword ? 'mdi-eye' : 'mdi-eye-off'"
        @click:append="showPassword = !showPassword"
        required
      ></v-text-field>

      <v-btn
        type="submit"
        color="primary"
        :loading="loading"
        :disabled="loading"
        @submit.prevent="signIn"
        rounded
        block
      >
        Login
      </v-btn>

      <v-row class="mt-2">
        <v-col class="text-right">
          <small>
            Don't have an account?
            <router-link to="/register">Register here.</router-link>
          </small>
        </v-col>
      </v-row>
    </v-form>
  </v-card>
</template>

<script>
import { mapGetters } from "vuex";

export default {
  computed: { ...mapGetters(["getUsers"]) },
  data() {
    return {
      email: "",
      password: "",
      showPassword: false,
      loading: false,
      error: null,
    };
  },
  methods: {
    signIn() {
      this.loading = true;
      this.error = null;
      this.showPassword = false;

      for (const user of this.getUsers) {
        if (user.email === this.email && user.password === this.password) {
          this.loading = false;
          this.$store.commit("SET_USER", user);
          this.$router.push({ name: "Home" });
          return;
        }
      }

      this.error = "Invalid credentials";
      this.loading = false;
    },
  },
};
</script>
